import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useEffect } from 'react';
import { FullPageLoader } from '@deal/components';
import { usePathContext } from '../../context/PathContext.js';
import deriveNodeNavigationDetails from '../../helpers/deriveNodeNavigationDetails.js';
import useHandleNextNode from '../../hooks/useHandleNextNode.js';
import { useVisitPathGraphFlowMutation } from '../../mutations/VisitPathGraphFlow.generated.js';
import BasicLayout from '../../themes/Basic/index.js';
import NotFound from '../NotFound/index.js';

var PathFlow = function PathFlow(_ref) {
  var pathGraphFlowId = _ref.pathGraphFlowId,
      directedActiveNodeSlugOrId = _ref.directedActiveNodeSlugOrId;
  var pathContext = usePathContext();
  var handleNextNode = useHandleNextNode(true);

  var _useVisitPathGraphFlo = useVisitPathGraphFlowMutation({
    variables: {
      input: {
        id: pathGraphFlowId
      }
    },
    onCompleted: function onCompleted(_ref2) {
      var visitPathGraphFlow = _ref2.visitPathGraphFlow;

      /**
       * If there were errors returned, set that state and don't attempt to
       * advance to the next node. If there isn't an active node, we have no
       * where to display the errors, this means our path failed even before
       * we started.
       */
      if (visitPathGraphFlow.error) {
        if (!pathContext.activeNode) {
          throw new Error('No active node and path graph flow returned errors');
        } else {
          pathContext.onSetPathGraphFlowErrors(visitPathGraphFlow.error);
        }

        return;
      }

      if (visitPathGraphFlow.pathGraphFlow) {
        pathContext.onSetPathGraphFlowErrors(undefined);
        pathContext.onSetPathGraphFlow(visitPathGraphFlow.pathGraphFlow);
        handleNextNode({
          pathGraphFlow: visitPathGraphFlow.pathGraphFlow,
          directedActiveNodeSlugOrId: directedActiveNodeSlugOrId
        });
      }
    }
  }),
      _useVisitPathGraphFlo2 = _slicedToArray(_useVisitPathGraphFlo, 2),
      visitPathGraphFlowMutation = _useVisitPathGraphFlo2[0],
      loading = _useVisitPathGraphFlo2[1].loading;

  useEffect(function () {
    /**
     * Execute this mutation once to get the latest state of the path. If the node wasn't updated,
     * there's no need to kick off a redundant call here.
     */
    var activeNodeDetails = pathContext.activeNode && deriveNodeNavigationDetails(pathContext.activeNode);
    /**
     * If there aren't any `activeNodeDetails`, that means we don't have an active node and this is
     * either a direct navigation to a node or this is the first visit.
     *
     * If there are node details, but for some reason the ID or external representation of the
     * node slug or ID doesn't match what our current active node is. Run a `visitPathGraphFlowMutation`
     * to true up the local state and external `directedActiveNodeSlugOrId`, favoring the external
     * value.
     */

    if (!activeNodeDetails || activeNodeDetails.nodeId !== directedActiveNodeSlugOrId && activeNodeDetails.nodeSlug !== directedActiveNodeSlugOrId) {
      visitPathGraphFlowMutation();
    }

    if (!window.tracking) {
      console.warn('TrackingClient not available in Path component');
    }
  }, [directedActiveNodeSlugOrId]);
  var activeNode = pathContext.activeNode;
  var pathGraphFlow = pathContext.pathGraphFlow;

  if (activeNode && pathGraphFlow) {
    /*
     * See `/path/themes/Basic` for more details on theme testing for paths
     */
    return React.createElement(BasicLayout, null);
  } else if (!activeNode || !pathGraphFlow || loading) {
    return React.createElement(FullPageLoader, null);
  }

  return React.createElement(NotFound, null);
};

export default PathFlow;
//# sourceMappingURL=index.js.map
